exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-virtual-scroll {\n  display: block;\n  flex: 1 1 auto;\n  height: 100%;\n  max-width: 100%;\n  overflow: auto;\n  position: relative;\n}\n.v-virtual-scroll__container {\n  display: block;\n}\n.v-virtual-scroll__item {\n  left: 0;\n  position: absolute;\n  right: 0;\n}", ""]);

// exports
